import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Button,
  Spinner,
  Badge,
} from "reactstrap"
import toast from "toastr"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { get_crm_orgs, sync_all_crm_orgs } from "helpers/backend_helper"
import ErpClientsTable from "../ErpClients/ErpClientsTable"

const isOk = res => res?.statusCode === 200 || res?.StatusCode === 200

const Index = () => {
  document.title = "CRM Organizations | TenderSoftware - Flexi TracBoard"

  const [orgs, setOrgs] = useState([])
  const [loading, setLoading] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)

  const loadOrgs = useCallback(async () => {
    setLoading(true)
    try {
      const res = await get_crm_orgs()
      setOrgs(res?.data || res?.Data || [])
    } catch (error) {
      toast.error(error?.message || "Failed to load CRM organizations")
      setOrgs([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadOrgs()
  }, [loadOrgs])

  const handleSyncAll = async () => {
    setSyncLoading(true)
    try {
      const res = await sync_all_crm_orgs()
      if (isOk(res)) {
        toast.success(res?.message || res?.Message || "Organizations synced from CRM")
        loadOrgs()
      } else {
        toast.error(res?.message || res?.Message || "Failed to sync organizations")
      }
    } catch (error) {
      toast.error(error?.message || "Failed to sync organizations from CRM")
    } finally {
      setSyncLoading(false)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Organization Name",
        accessor: "organization_name",
        Cell: ({ row }) => row.original.organization_name || row.original.name,
      },
      {
        Header: "ERP Id",
        accessor: "name",
      },
      {
        Header: "Country",
        accessor: "tsi_country",
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Status",
        accessor: "tsi_client_status",
        Cell: ({ value }) =>
          value === "Active Client" ? (
            <Badge color="success">Active</Badge>
          ) : (
            <Badge color="secondary">{value || "Inactive"}</Badge>
          ),
      },
      {
        Header: "Action",
        disableSortBy: true,
        Cell: ({ row }) => (
          <Link
            to={`/crm-organization/${encodeURIComponent(row.original.name)}`}
            className="btn btn-sm btn-outline-primary"
          >
            View
          </Link>
        ),
      },
    ],
    []
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title={"CRM Organizations"} breadcrumbItem={"CRM Organizations"} />
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">CRM Organizations</h5>
                <Button color="primary" onClick={handleSyncAll} disabled={syncLoading}>
                  {syncLoading ? (
                    <>
                      <Spinner size="sm" className="me-1" /> Syncing...
                    </>
                  ) : (
                    <>
                      <i className="mdi mdi-sync me-1" /> Sync from CRM
                    </>
                  )}
                </Button>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <div className="text-center p-5">
                    <Spinner /> Loading organizations...
                  </div>
                ) : (
                  <ErpClientsTable columns={columns} data={orgs} customPageSize={15} />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Index
